import {adminHttp} from "~/Admin/services/http";

export const loadEventsAction = () => async (dispatch) => {

    const response = await adminHttp.get('/events');

    dispatch({
        type: 'LOAD_EVENTS',
        payload: response.data || null
    });
};

export const setCurrentEvent = (eventId) => ({
    type: "SET_CURRENT_EVENT",
    payload: eventId
})

export const updateEvent = (event) => ({
    type: "UPDATE_EVENT",
    payload: event
})
